import { Box, Card, CardContent, Typography, Stack } from "@mui/material";

export default function FormPage({ title, subtitle, children, maxWidth = 440 }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: { xs: 2, sm: 4 } }}>
      <Card sx={{ width: "100%", maxWidth }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Typography variant="h5" component="h1" sx={{ fontWeight: 700, letterSpacing: "-0.015em" }}>
                {title}
              </Typography>
              {subtitle ? (
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                  {subtitle}
                </Typography>
              ) : null}
            </Stack>
            {children}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
